import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCurrentCellularPricePlan } from '../../../Block/ChangePricePlanBlock/changePricePlanSlice';
import Skeleton from 'react-loading-skeleton';
import { isMobile } from 'react-device-detect';
import 'react-loading-skeleton/dist/skeleton.css';
import { setPackageInfo } from '../../../../Components/Page/SelfCarePage/SelfCareSlice';

const TooltipPackageInfo = (props) => {
  const [visible, setVisible] = useState(false);
  const [currentPackage, setCurrentPackage] = useState(null);
  const infoIcon = props.icon ?? require('../images/moreInfo.svg');
  const position = props.position ?? isMobile ? 'right' : 'left';

  useEffect(() => {
    setCurrentPackage(null);
    setVisible(false);
  }, [props.selectedSubscriber?.productSubscriberNo]);

  const getPackageInfo = async () => {
    const currentSub = props.subscriberByProduct[props.selectedSubscriber?.productType].find(sub => sub.productSubscriberNo === props.selectedSubscriber?.productSubscriberNo);
    if (!currentPackage) {
      if (currentSub.packageInfo) {
        setCurrentPackage(currentSub.packageInfo);
      } else {
        await props.getCurrentCellularPricePlan({ subscriberNo: currentSub.productSubscriberNo }).then((res) => {
          setCurrentPackage(res.payload.data.pp_details_desc);
          props.setPackageInfo(res.payload.data.pp_details_desc);

        });
      }
    }
  };


  ;

  return (
    <div
      className='TooltipPackage-container'
      onMouseEnter={() => {
        setVisible(true);
        getPackageInfo();
      }}
      onMouseLeave={() =>
        setVisible(false)}>
      <Image src={infoIcon} />
      {visible && (
        <>
          <div className={`tooltipPackage  ${position}`}>
            <div className={`${position} pointer`}> </div>
            <div className='PackageInfo_text'>
              {currentPackage ? (
                <>
                  <p className='title'>מה בחבילה ? </p>
                  <p className='text'>{currentPackage}</p>
                </>
              ) : (
                <Skeleton count={isMobile ? 10 : 5} />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    worldType: state.selfcarePage.epiData.worldType,
    selectedSubscriber: state.selfcarePage?.selectedSubscriber,
    subscriberByProduct: state.selfcarePage?.subscribersByProduct,
  };
};

const mapDispatchToProps = {
  getCurrentCellularPricePlan,
  setPackageInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(TooltipPackageInfo);
